import React, { useState } from 'react';
import { Stack } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsCalendarDateFill } from "react-icons/bs";
import './Test.css'; // Create this CSS file

export default function Test() {
  const [selectedDate, setSelectedDate] = useState(null);

  const onChange = (date) => {
    setSelectedDate(date);
    console.log("Selected date:", date);
  };

  return (
    <div className="test-container">
      <h1>Date Picker Demo</h1>     
    </div>
  );
}